import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "../../actions/actions";
import { ComposicaoModel } from "../../../models/composicao/composicaoModel";
import { listarComposicao, listarComposicoesSalvas, obterComposicaoSalva, verificarComposicaoSalva } from "../../../services/composicaoService";
import { FechamentoResultadoSorteioModel } from "../../../models/composicao/fechamentoResultadoSorteioModel";
import { ListarComposicaoModel } from "../../../models/composicao/listarComposicaoModel";
import { ComposicaoSalvaModel } from "../../../models/composicao/composicaoSalvaModel";
import { ComposicaoSalvaInfoModel } from "../../../models/composicao/composicaoSalvaInfoModel";
import dayjs from "dayjs";

dayjs.locale("pt-br");

export interface ComposicaoState {
  //buscar composicao
  loading: boolean;
  busca: ListarComposicaoModel;
  list: FechamentoResultadoSorteioModel[];
  entity: ComposicaoModel;
  //composicoes salvas
  composicaoSalvaInfo: ComposicaoSalvaInfoModel | null;
  composicoesSalvas: ComposicaoSalvaModel[];
  loadingComposicoesSalvas: boolean;
  exibindoComposicaoSalva: ComposicaoSalvaInfoModel | null;
}

const initialState: ComposicaoState = {
  //buscar composicao
  loading: false,
  busca: {
    dataInicio: dayjs().startOf("month").toDate(),
    dataFim: dayjs().endOf("month").toDate(),
    listaEmpresa: null,
    tipoFiltroData: "SORT",
  } as ListarComposicaoModel,
  list: [],
  entity: {} as ComposicaoModel,
  //composicoes salvas
  composicaoSalvaInfo: null,
  composicoesSalvas: [],
  loadingComposicoesSalvas: false,
  exibindoComposicaoSalva: null,
};

export const composicaoSlice = createSlice({
  name: "composicao",
  initialState,
  reducers: {
    //buscar composicao
    setBuscaComposicao: (state, action) => {
      state.busca = action.payload;
    },
    //composicoes salvas
    setExibindoComposicaoSalva: (state, action) => {
      state.exibindoComposicaoSalva = action.payload;
    },
    //internal
    resetComposicao: () => initialState,
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //listar composição
    builder.addCase(listarComposicao.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(listarComposicao.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
      //cálculo ao vivo substitui o snapshot salvo em exibição
      state.exibindoComposicaoSalva = null;
    });
    builder.addCase(listarComposicao.rejected, (state, action) => {
      state.loading = false;
    });

    //verificar composição salva (match dos filtros atuais)
    builder.addCase(verificarComposicaoSalva.fulfilled, (state, action) => {
      state.composicaoSalvaInfo = action.payload;
    });
    builder.addCase(verificarComposicaoSalva.rejected, (state) => {
      state.composicaoSalvaInfo = null;
    });

    //listar composições salvas
    builder.addCase(listarComposicoesSalvas.pending, (state) => {
      state.loadingComposicoesSalvas = true;
    });
    builder.addCase(listarComposicoesSalvas.fulfilled, (state, action) => {
      state.composicoesSalvas = action.payload;
      state.loadingComposicoesSalvas = false;
    });
    builder.addCase(listarComposicoesSalvas.rejected, (state) => {
      state.loadingComposicoesSalvas = false;
    });

    //obter composição salva (snapshot vai para a mesma grid)
    builder.addCase(obterComposicaoSalva.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(obterComposicaoSalva.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(obterComposicaoSalva.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar composicao
  setBuscaComposicao,
  //composicoes salvas
  setExibindoComposicaoSalva,
  //internal
  resetComposicao,
} = composicaoSlice.actions;

export default composicaoSlice.reducer;
